<template>
    <v-container fluid>
        <v-btn
            :loading="customersWithInfo === null"
            @click="newCustomer"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Customers ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >

                            <v-btn
                            v-if="canImport"
                    @click="showImportForm = !showImportForm"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-star-outline</v-icon>
                </v-btn>
                <v-btn
                    @click="showReportForm = !showReportForm"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
                <v-btn
                    @click="showLogReportForm = !showLogReportForm"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-view-list-outline</v-icon>
                </v-btn>
                <v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="customersWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="customerWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="customerWithInfo in customersWithInfo"
                >
                    <v-card
                        @click="loadCustomerForm(customerWithInfo.entity)"
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                    >
                        <v-card-title>
                            <h5>{{ customerWithInfo.info.customerFullName }}</h5>
                        </v-card-title>
                        <v-card-subtitle>
                            {{
                            customerWithInfo.info.identificationNumber
                            }}
                        </v-card-subtitle>

                        <div>
                            <v-card-text class="center-content pa-2">
                                <v-row justify="space-around">
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card
                                            @click.stop="
                                                if (
                                                    customerWithInfo.entity
                                                        .identity
                                                        .idDocumentFileId > 0
                                                )
                                                    $store.dispatch(
                                                        'files/get',
                                                        {
                                                            fileId:
                                                                customerWithInfo
                                                                    .entity
                                                                    .identity
                                                                    .idDocumentFileId,
                                                            namePrefix:
                                                                customerWithInfo
                                                                    .entity
                                                                    .identity
                                                                    .id +
                                                                '_Identity',
                                                        }
                                                    );
                                            "
                                            class="pa-1 ma-1 fill-height"
                                        >
                                            Identity Doc
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="
                                                        customerWithInfo.entity
                                                            .identity
                                                            .idDocumentFileId
                                                    "
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="info"
                                                    v-else-if="
                                                        customerWithInfo.entity
                                                            .identity
                                                            .idDocumentAvailable
                                                    "
                                                >mdi-alpha-a-circle</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card
                                            :href="
                                                customerWithInfo.info
                                                    .applicationFormLink
                                                    ? filesUrl +
                                                      customerWithInfo.info
                                                          .applicationFormLink +
                                                      'ApplicationForm_' +
                                                      customerWithInfo.entity.id
                                                    : ''
                                            "
                                            @click.stop="
                                                if (
                                                    customerWithInfo.entity
                                                        .applicationFormFileId > 0
                                                )
                                                    $store.dispatch(
                                                        'files/get',
                                                        {
                                                            fileId:
                                                                customerWithInfo
                                                                    .entity
                                                                    .applicationFormFileId,
                                                            namePrefix:
                                                                customerWithInfo
                                                                    .entity
                                                                    .id +
                                                                '_ApplicationForm',
                                                        }
                                                    );
                                            "
                                            class="pa-1 ma-1 fill-height"
                                            target="_blank"
                                        >
                                            Application
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="
                                                        customerWithInfo.entity
                                                            .applicationFormFileId
                                                    "
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Subscribed
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="
                                                        customerWithInfo.entity
                                                            .subscriptionId > 0
                                                    "
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Status
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="
                                                        customerWithInfo.entity
                                                            .customerStatus == 2
                                                    "
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else-if="
                                                        customerWithInfo.entity
                                                            .customerStatus == 3
                                                    "
                                                >mdi-close</v-icon>
                                                <v-icon
                                                    color="warning"
                                                    v-else-if="
                                                        customerWithInfo.entity
                                                            .customerStatus == 1
                                                    "
                                                >mdi-map-marker-question-outline</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                        <v-card-text>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-if="customerWithInfo.entity.cardNumber"
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-card-text</v-icon>
                                {{ customerWithInfo.entity.cardNumber }}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-if="customerWithInfo.info.signedUpByFullName"
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-plus-thick</v-icon>
                                {{ customerWithInfo.info.signedUpByFullName }}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-if="customerWithInfo.info.companyName"
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-office-building</v-icon>
                                {{ customerWithInfo.info.companyName }}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-if="customerWithInfo.info.email"
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-at</v-icon>
                                {{ customerWithInfo.info.email }}
                            </v-chip>

                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-if="customerWithInfo.info.phone"
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-phone-classic</v-icon>
                                {{ customerWithInfo.info.phone }}
                            </v-chip>
                          <customer-status-chip v-if="customerWithInfo && customerWithInfo.entity"
                                                :customer-company-id="customerWithInfo.entity.customerCompanyId"
                                                :customer-status-company="customerWithInfo.entity.customerStatusCompany"
                                                :customer-status-individual="customerWithInfo.entity.customerStatusIndividual"/>

                        </v-card-text>
                        <!--<v-card-text class="pt-0">
                            Footer Text
                        </v-card-text>-->
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="customerFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeCustomerForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Customer Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row
                        align="center"
                        justify="center"
                        v-if="true"
                    >
                        <CustomerForm
                            :companies="companiesList"
                            :customer-in="customerFormCustomer"
                            :key="customerFormKey"
                            :statuses="statusOptions"
                            :subscriptions="subcriptionsList"
                            @close="closeCustomerForm"
                            @deleted="deleteCustomer"
                            @saved="updateCustomer"
                        />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>
                <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showImportForm"
            width="350px"
        >
            <AccisureCustomerImportForm @close="showImportForm = false" />
        </v-dialog>
        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showReportForm"
            width="350px"
        >
            <AccisureComissionReportForm @close="showReportForm = false" />
        </v-dialog>
        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showLogReportForm"
            width="350px"
        >
            <AccisureCustomerLogReportForm @close="showLogReportForm = false" />
        </v-dialog>
        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showFilters"
            width="350px"
        >
            <v-card>
                <v-card-title>Customer Filtering</v-card-title>
                <v-card-text>
                    <!--<v-divider></v-divider>-->
                    <v-switch
                        @change="paginationDebounce(filterDebounceTime)"
                        class="mb-0"
                        label="Status"
                        v-model="filterOnStatus"
                    ></v-switch>
                    <!--<v-select
                        :disabled="!filterOnStatus"
                        :items="statusOptions"
                        @change="paginationDebounce(filterDebounceTime)"
                        class="my-0"
                        item-text="name"
                        item-value="value"
                        style="max-width: 200px"
                        v-model="filterStatus"
                    ></v-select>-->
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="resetFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Reset</v-btn>
                    <v-btn
                        @click="showFilters = !showFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
<!-- Displaying Change List -->

        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import Customer from "../models/Customer.model";
import uuid4 from "../helpers/uuid4";
import { FilesUrl } from "../services/axios.service";
import Customer from "../models/Customer.model";
import CustomerForm from "../components/forms/CustomerForm";
import AccisureComissionReportForm from "../components/forms/AccisureComissionReportForm";
import AccisureCustomerLogReportForm from "../components/forms/AccisureCustomerLogReportForm";
import AccisureCustomerImportForm from "../components/forms/AccisureCustomerImportForm";
import RoleType from "../constants/RoleType.constant";
import CustomerStatusChip from "@/components/widgets/Customers/CustomerStatusChip.vue";


export default {
    name: "Customers",
    props: ["status", "companyId"],
    data: function() {
        return {

            filesUrl: FilesUrl,
            //main data
            customersWithInfo: null,
            companiesList: null,
            subcriptionsList: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),
            //form data
            //customerFormVisible: false,
            //customerFormKey: 0,
            //customerFormCustomer: new Customer()
            //filters
            showReportForm: false,
            showImportForm: false,
            showLogReportForm: false,
            showFilters: false,
            filterDebounceTime: 500,
            filterOnStatus: this.status !== undefined,
            //filterStatus: isNaN(this.status) ? 1 : parseInt(this.status),
            statusOptions: [
                //{ name: "Incomplete", value: 1 },
                //{ name: "Complete", value: 2 },
                //{ name: "Cancelled", value: 3 }
            ],

            //form
            customerFormVisible: false,
            customerFormKey: 0,
            customerFormCustomer: new Customer(),

            userRoles: [],
        };
    },
        created: async function() {
        this.userRoles = await this.$store.dispatch(
            "authentication/getUserRoles"
        );
    },
    mounted: function() {
        this.getCustomers();
        this.getCompaniesList();
        this.getSubscriptionsList();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        CustomerStatusChip,
        CustomerForm,
        AccisureComissionReportForm,
        AccisureCustomerLogReportForm,
        AccisureCustomerImportForm
        //
    },
    computed:{
                canImport: function() {
                        return this.userRoles.some(x => x == RoleType.Admin);
        },
    },
    methods: {
       
        getCustomers() {
            var requestId = (this.requestId = uuid4());
            var urlParameters = {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder,
                        //status: //this.filterOnStatus ? this.filterStatus : null,
                    };

            if(this.status !== undefined)
            urlParameters.status = this.status;

            if(this.companyId > 0)
            urlParameters.companyId = this.companyId

            this.$store
                .dispatch("customers/get", {
                    id: null,
                    urlParameters: urlParameters,
                    requestId: requestId
                })
                .then(customersResponse => {
                    if (this.requestId == customersResponse.requestId) {
                        this.customersWithInfo = customersResponse.data.page;
                        this.totalMatches = customersResponse.data.total;
                        this.pageSize = customersResponse.data.pageSize;
                        this.pageNo = customersResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            customersResponse.data.total / this.pageSize
                        );
                    }
                });
        },
        getCompaniesList() {
            this.$store.dispatch("companies/getlist").then(response => {
                this.companiesList = response;
            });
        },

        getSubscriptionsList() {
            this.$store.dispatch("subscriptions/getlist").then(response => {
                this.subcriptionsList = response;
            });
        },

        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.customersWithInfo !== null) this.customersWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getCustomers,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },
        resetFilters() {
            this.filterOnStatus = false;
            //this.filterStatus = 1;
            this.paginationDebounce(0);
        },

        //FORM METHODS---------------------------------
        newCustomer() {
            var customer = new Customer();
            customer.id = 0;
            this.loadCustomerForm(customer);
        },
        loadCustomerForm(customer) {
            this.customerFormCustomer = customer; //new Customer().set(customer);
            this.customerFormKey = customer.id;
            this.customerFormVisible = true;
        },
        closeCustomerForm() {
            this.paginationDebounce(0, true);
            this.customerFormVisible = false;
            this.customerFormCustomer = new Customer();
            this.customerFormKey = null;
        },
        updateCustomer() {
            this.paginationDebounce(0, true);
        },
        deleteCustomer() {
            this.paginationDebounce(0, true);
        }
    }
};
</script>

<style lang="stylus" scoped>
.entity-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
